<template>
    <div v-if="!loading"
         class="filter-items -mx-2 px-2">
        <div>
            <div class="flex justify-between w-full">
                <div class="mb-0">
                    <div class="flex items-center pb-4">
                        <i :class="localModel.ParameterIcon" class="text-primary mx-w-4-5 text-xl" />
                        <span class="mx-2 font-medium text-xl main-text-color">
                            {{ getTemplateParameterHelpName(localModel) }}
                        </span>
                        <div
                            v-if="getTemplateParameterHelpDescription(localModel)"
                            class="flex items-center category-wrapper hover:text-primary cursor-pointer"
                        >
                            <el-tooltip
                                :content="getTemplateParameterHelpDescription(localModel)"
                                :open-delay="200"
                                placement="top">
                                <span class="mx-2 truncate">
                                    <i class="vc-icon-info cursor-help text-primary text-2xl"></i>
                                </span>
                            </el-tooltip>
                        </div>
                    </div>
                </div>
            </div>
            <base-select
                class="py-2 select"
                filterable
                :loading="loading"
                :v-on="$listeners"
                :collapse-tags="collapseTags"
                multiple
                :value="autocompleteValue"
                @change="onAutocompleteChange"
                :data="options"
                :label-key="templateConfig.label"
                :second-label-key="templateConfig.second_label"
                :value-key="templateConfig.value">
            </base-select>
        </div>
    </div>
</template>

<script>
import {Option, Select} from "element-ui";
import get from "lodash/get";
import cloneDeep from "lodash/cloneDeep";
import {getTemplateConfig} from "@/helpers/entitiesList";

export default {
    name: "MultiSelect",
    components: {
        [Select.name]: Select,
        [Option.name]: Option,
    },
    props: {
        model: {
            type: Object,
            default: () => ({}),
        },
    },
    data () {
        return {
            options: [],
            loading: true,
            collapseTags: true,
            templateConfig: getTemplateConfig(this.model.ParameterName),
            localModel: {},
            autocompleteValue: []
        }
    },
    watch: {
        model: {
            immediate: true,
            deep: true,
            handler (newV) {
                if (newV && this.localModel !== newV) {
                    this.localModel = newV
                }
            }
        },
        localModel: {
            immediate: true,
            deep: true,
            handler (newV) {
                if (newV.WidgetParameterJson === 1) {
                    this.autocompleteValue = newV.WidgetParameterValueJson || []
                } else {
                    this.autocompleteValue = JSON.parse(newV.WidgetParameterValue) || []
                }
                this.model = newV
                this.$emit('update-model', this.model)
            }
        }
    },
    methods: {
        getData() {
            let templateConfig = getTemplateConfig(this.localModel.ParameterName)
            let EntitiesListKey = get(templateConfig, 'EntitiesListKey')
            this.options = get(this.localModel.ParameterData, EntitiesListKey, [])
            this.loading = false
        },
        getTemplateParameterHelpName (model) {
            if (model.TemplateParameterHelp && model.TemplateParameterHelp.ParameterTitleTag) {
                return this.$t(model.TemplateParameterHelp.ParameterTitleTag)
            }

            if (model.ParameterTitleTag) {
                return this.$t(model.ParameterTitleTag)
            }

            if (model.TemplateParameterHelp && model.TemplateParameterHelp.ParameterTitle) {
                return model.TemplateParameterHelp.ParameterTitle
            }

            return model.ParameterPrettyName
        },
        getTemplateParameterHelpDescription (model) {
            if (model.TemplateParameterHelp && model.TemplateParameterHelp.ParameterDescriptionTag) {
                return this.$t(model.TemplateParameterHelp.ParameterDescriptionTag)
            }

            if (model.ParameterDescriptionTag) {
                return this.$t(model.ParameterDescriptionTag)
            }

            if (model.TemplateParameterHelp && model.TemplateParameterHelp.ParameterDescription) {
                return model.TemplateParameterHelp.ParameterDescription
            }

            return model.ParameterDescription
        },
        onAutocompleteChange(value) {
            if (this.localModel.WidgetParameterJson === 1) {
                this.localModel.WidgetParameterValueJson = cloneDeep(value)
            } else {
                this.localModel.WidgetParameterValue = JSON.stringify(value)
            }
        },
    },
    mounted() {
        this.getData()
    },
}
</script>

<style scoped>

</style>
